<template>
  <div>
    {{ descrip }}
    <span
      class="pointer cust-link cursor-pointer"
      v-if="viewMore && description.length > textLength"
      @click="viewMore = false"
      >View more</span
    >
    <span
      class="pointer cust-link cursor-pointer"
      v-if="!viewMore && description.length > textLength"
      @click="viewMore = true"
      ><br />View less</span
    >
  </div>
</template>
<script>
export default {
  props: ['description'],
  data() {
    return {
      viewMore: true,
      windowWidth: window.innerWidth
    };
  },
  computed: {
    textLength() {
      let txtLength = 320;
      if (this.windowWidth < 767) {
        txtLength = 100;
      }
      if (window.innerWidth > 767 && window.innerWidth < 1200) {
        txtLength = 200;
      }
      return txtLength;
    },
    descrip() {
      let totalDescription = this.description;
      const slcTxtLen = this.textLength - 20;
      if (this.viewMore && this.description.length > this.textLength) {
        totalDescription = `${this.description.slice(0, slcTxtLen)}... `;
      }
      return totalDescription;
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.windowWidth = window.innerWidth;
    });
  }
};
</script>
<style lang="scss" scoped>
.cust-link {
  margin-top: 5px;
  color: $messenger-blue;
  font-size: $font-14;
}
@media screen and (max-width: 767px) {
  .cust-link {
    font-size: $font-10;
  }
}
</style>
